export enum FileType {
    PDF = 'pdf',
    EXCEL = 'excel',
    CSV = 'csv'
}
